import { render, staticRenderFns } from "./VideoManage.vue?vue&type=template&id=37c5bc47&scoped=true&"
import script from "./VideoManage.vue?vue&type=script&lang=js&"
export * from "./VideoManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5bc47",
  null
  
)

export default component.exports